<template>
  <div class="common-layout">
    <el-container class="layout-container">

      <!-- Header -->
      <el-header class="layout-header">
        <div class="header-inner">
          <!-- 手机端菜单按钮 -->
          <el-button
            v-if="isMobile"
            @click="drawer = true"
            circle
          >
            ☰
          </el-button>

          <PageHeader />
        </div>
      </el-header>

      <el-divider />

      <el-container>

        <!-- PC端侧栏 -->
        <div
          v-if="!isMobile"
          class="aside-shell"
          :class="{ 'is-collapsed': isAsideCollapsed }"
        >
          <el-aside
            :width="isAsideCollapsed ? '0px' : '188px'"
            class="layout-aside"
          >
            <NavBar @nav-click="handleNavClick" />
          </el-aside>

          <button
            class="aside-toggle"
            type="button"
            :aria-label="isAsideCollapsed ? '展开侧栏菜单' : '收起侧栏菜单'"
            :title="isAsideCollapsed ? '展开侧栏菜单' : '收起侧栏菜单'"
            @click="toggleAside"
          >
            <el-icon>
              <ArrowRight v-if="isAsideCollapsed" />
              <ArrowLeft v-else />
            </el-icon>
          </button>
        </div>

        <!-- 主内容 -->
        <el-main class="layout-main">
          <router-view />
        </el-main>

      </el-container>
    </el-container>

    <!-- 手机端抽屉导航 -->
    <el-drawer
      v-model="drawer"
      direction="ltr"
      size="200px"
      v-if="isMobile"
    >
      <NavBar @nav-click="handleNavClick" />
    </el-drawer>

  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import NavBar from '@/components/NavBar.vue'
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'

export default {
  name: 'HomePage',
  components: {
    PageHeader,
    NavBar,
    ArrowLeft,
    ArrowRight
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      drawer: false,
      isAsideCollapsed: localStorage.getItem('webford-aside-collapsed') === '1'
    }
  },
  methods: {
    handleNavClick(navName) {
      this.drawer = false
      this.$router.push({ name: navName.name })
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    toggleAside() {
      this.isAsideCollapsed = !this.isAsideCollapsed
      localStorage.setItem('webford-aside-collapsed', this.isAsideCollapsed ? '1' : '0')
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>

/* 关键：避免内容撑爆 */
.layout-main {
  min-width: 0;
  padding-left: 0;
  padding-right: 0;
  background: var(--wf-page-bg);
  color: var(--wf-text-primary);
}

.common-layout,
.layout-container {
  min-height: 100vh;
  background: var(--wf-page-bg);
}

/* Header 内部布局 */
.layout-header {
  height: auto;
  padding: 10px 18px 8px;
  background: var(--wf-surface);
  border-bottom: 1px solid var(--wf-border);
}

.header-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

/* 去除 aside 内边距问题 */
.aside-shell {
  position: relative;
  flex: 0 0 auto;
  height: calc(100vh - 82px);
  overflow: visible;
  transition: width 0.22s ease;
}

.aside-shell.is-collapsed {
  width: 0;
}

.layout-aside {
  height: calc(100vh - 82px);
  overflow-x: hidden;
  overflow-y: hidden;
  background: transparent;
  transition: width 0.22s ease;
}

.aside-shell.is-collapsed .layout-aside {
  border: 0;
}

.aside-toggle {
  position: fixed;
  top: 44vh;
  left: 184px;
  z-index: 1000;
  width: 22px;
  height: 22px;
  padding: 0;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(191, 219, 254, 0.95);
  border-radius: 999px;
  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);
  color: #2563eb;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.12);
  transform: translateY(-50%);
  transition: left 0.22s ease, transform 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.aside-shell.is-collapsed .aside-toggle {
  left: 10px;
}

.aside-toggle .el-icon {
  font-size: 11px;
}

.aside-toggle:hover {
  color: #075985;
  border-color: rgba(56, 189, 248, 0.95);
  transform: translateY(-50%) translateX(1px);
  box-shadow: 0 10px 22px rgba(14, 165, 233, 0.18);
}

/* Divider 微调 */
.el-divider--horizontal {
  display: none;
}

:global(html.dark .aside-toggle) {
  border-color: var(--wf-border);
  background: linear-gradient(135deg, var(--wf-surface-elevated) 0%, var(--wf-surface-soft) 100%);
  color: #7dd3fc;
  box-shadow: 0 8px 18px var(--wf-shadow);
}

:global(html.dark .aside-toggle:hover) {
  color: #bae6fd;
  border-color: rgba(56, 189, 248, 0.58);
  box-shadow: 0 10px 22px var(--wf-shadow);
}

/* 手机强制纵向结构 */
@media (max-width: 768px) {
  .layout-container {
    flex-direction: column !important;
  }

  :deep(.el-drawer__body) {
    padding: 0;
  }
}

</style>
